import errorHandler from '../helper/error';
import messageHandler from '../helper/message';

const actions = {
    APP_INIT ({state, commit, dispatch, rootState}, callback) {

        // if(rootState.$helper.helper.getParamers('game_code')){
        //     rootState.$helper.cookie.set('odp-selectedGameCode', rootState.$helper.helper.getParamers('game_code'));
        // }

        /**设置页面Title**/
        if (rootState.$page !== 'index') {
            dispatch('SET_TITLE');
        }

        /**localStorage取游戏列表*/
        let gameList = rootState.$helper.localStorage.get('odp_gameList');
        if (gameList) {
            new rootState.$helper.loginHandle({state, commit, dispatch, rootState}, gameList, callback);
            return;
        }

        /**远端取游戏列表**/
        let options = [
            {url: rootState.$config.api.app.get_game_list, method: 'get', key: 'gamelist', data: {isGameCode: false}}
        ];

        rootState.$helper.request.all(options,
            (res) => {
                console.log('APP_INIT=>', res);
                /**本地存储**/
                rootState.$helper.localStorage.set('odp_gameList', res, 0.5);

                /**调用用户登陆统一处理**/
                new rootState.$helper.loginHandle({state, commit, dispatch, rootState}, res, callback);
            },
            (res) => {
                /**无权限返回内容**/
                if (res['response'] &&
                    res['response']['data'] &&
                    res['response']['data']['mess']
                ) {
                    let message = res['response']['data']['mess'];
                    if (message === 'No permission to access this url') {
                        /**已在无权限提示页面不再跳转**/
                        if (rootState.$page !== 'noAccess') {
                            rootState.$route('noAccess');
                        } else {
                            let data = {};
                            data['gamelist'] = {};
                            data['gamelist']['data'] = {};
                            data['gamelist']['data']['games'] = [];
                            data['gamelist']['data']['games_admin'] = [];
                            data['gamelist']['data']['user'] = {};
                            data['gamelist']['data']['user']['email'] = '无权限访客';

                            /**设置用户信息和游戏信息**/
                            commit('updateAppInfo', data);

                            /**设置用户权限对象**/
                            commit('updateUserRoles', {res: data, rootState});

                            /**设置用户无权限对象**/
                            commit('NO_ACCESS_PAGE', {args: data, status: false, state, commit, dispatch, rootState});
                            callback();
                        }
                        return;
                    }
                }

                /**用户登陆验证**/
                if (res['response']
                    && res['response']['data']
                    && res['response']['data']['exception']
                    && res['response']['data']['exception']['message']
                ) {
                    let message = res['response']['data']['exception']['message'];
                    errorHandler.noAccessPage(message, rootState);
                }
            });
    },

    GET_ACTIVE_GAME_INFO ({state, commit, dispatch, rootState}, callback) {
        let url = rootState.$config.api.app.get_game_info;
        rootState.$helper.request.get(url)
            .then((res) => {
                dispatch('UPDATE_ACTIVE_GAME_INFO', {
                    res: res['data']['games'][0],
                    type: (callback === null ? true : false)
                });
                if (typeof callback === 'function') callback(res);
            })
            .catch((res) => {
                console.log(res);
            });
    },

    /***
     * 更新游戏信息
     * @constructor
     */
    UPDATE_ACTIVE_GAME_INFO ({state, commit, dispatch, rootState}, {res, type}) {
        commit('_updateActiveGameInfo', {gameinfo: res, rootState, type});
    },

    ACCESS_STATUS ({state, commit, dispatch, rootState}, status) {
        commit('_updateAccessStatus', status);
    },

    /**
     * 更新$loading状态
     * @constructor
     */
    LOADING ({state, commit, dispatch, rootState}, args) {
        commit('_updateLoading', args);
    },

    /**
     * 存储$vue
     * @constructor
     */
    SAVE_VUE_OBJECT ({state, commit, dispatch, rootState}, $vue) {
        commit('_updateSaveVueObject', $vue);
    },

    /**
     * 请求错误统一处理
     * @constructor
     */
    ERROR_HANDLE ({state, commit, dispatch, rootState}, e) {
        errorHandler.error(e, {state, commit, dispatch, rootState});
    },

    /**
     * 提示
     * @constructor
     * arge.message 提示文案
     * arge.callback 关闭回调用方法
     * args.reload 关闭回调用方法 默认false
     */
    MESSAGE_HANDLE ({state, commit, dispatch, rootState}, arge) {
        messageHandler.message(arge, {state, commit, dispatch, rootState});
    },

    /**
     * 提示
     * @constructor
     * args.message 弹窗层提示
     * args.callback 关闭回调用方法
     * args.reload 关闭回调用方法 默认false
     */
    ALERT_HANDLE ({state, commit, dispatch, rootState}, args) {
        messageHandler.alert(args, {state, commit, dispatch, rootState});
    },

    /**
     * 设置页面
     * @constructor
     */
    SET_TITLE ({state, commit, dispatch, rootState}) {
        let arr = state.$page.split('/');
        let title = '';
        if (arr.length > 1) {
            title = rootState.$routerMapsDefined[arr[0]]['children'][arr[1]]['title'];
        } else {
            title = rootState.$routerMapsDefined[arr[0]]['title'];
        }
        commit('_setTitle', title);
    },

    /**
     * 用户退出
     * @constructor
     */
    LOGOUT ({state, commit, dispatch, rootState}, args) {
        alert('LOGOUT');
    },

};

export default actions;



// WEBPACK FOOTER //
// ./website/store/actions.js